import React from 'react';

type ComponentObject = { [key: string]: any };

export function withSubComponents<TMain extends React.ComponentType<any>, TSub extends ComponentObject>(
    mainComponent: TMain,
    subComponents: TSub
): TMain & TSub {
    for (const key of Object.keys(subComponents)) {
        (mainComponent as any)[key] = subComponents[key];
    }

    return mainComponent as TMain & TSub;
}